import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ShipAddressEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/locales/ShipAddress_en_US';
import ShipAddressFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/locales/ShipAddress_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(ShipAddressEN, ShipAddressFR);

export const newShipAddressSelector = createStructuredSelector({
    defaultAddressUpdatedDone: getTextFromResource(getText, 'defaultAddressUpdatedDone'),
    selectNewDefaultAddressDone: getTextFromResource(getText, 'selectNewDefaultAddressDone')
});
